import React from 'react';
import ContentLayout from 'components/ContentLayout';

function Shipment() {
  return (
    <ContentLayout>
      <h1>Shipment</h1>
    </ContentLayout>
  );
}

export default Shipment;
